import React from 'react';

import { Nav } from './components/Nav';
import { NavButton } from './components/NavButton';

export const Header = () => (
    <div className="statspro-header">
        <div className='statspro-header__wrapper wrapper mb-0'>
            <div className="statspro-header__search-wrapper"></div>
            <div className="statspro-header__nav-wrapper">
                <Nav />
            </div>
            <div className="statspro-header__glossary-wrapper">
                <NavButton
                    text="Glossary"
                    icon="info-circle"
                />
            </div>
        </div>
    </div>
);
